import {
	blue400,
	neutral200, neutral400, neutralWhite,
	primary400, primary50, primary500, primary700, primary800,
	red25, red50, red100, red300, red500,
} from '../themes/colors';

export const buttonVariants = [
	'white',
	'default',
	'primary',
	'secondary',
	'danger',
	'ghost',
	'link',
	'gradient',
] as const;

export type ButtonVariant = typeof buttonVariants[number];

type StateColorsDefinition = {
	default: string;
	hover: string;
	active: string;
	disabled: string;
}

export type IconPosition = 'left' | 'right';

export type ButtonColorDefinition = {
	opacity: number;
	background: StateColorsDefinition;
	color: StateColorsDefinition;
	icon: StateColorsDefinition;
	border: StateColorsDefinition | null;
}

const sameColorEveryState = (color: string) : StateColorsDefinition => ({
	default: color,
	hover: color,
	active: color,
	disabled: color,
});

export const ButtonColors: {[key in ButtonVariant]: ButtonColorDefinition} = {
	default: {
		opacity: 0.1,
		background: {
			default: neutralWhite,
			hover: neutralWhite,
			active: neutralWhite,
			disabled: neutralWhite,
		},
		icon: {
			default: primary800,
			hover: blue400,
			active: primary500,
			disabled: primary800,
		},
		color: {
			default: primary800,
			hover: blue400,
			active: primary500,
			disabled: primary800,
		},
		border: {
			default: neutral200,
			hover: blue400,
			active: primary500,
			disabled: primary500,
		},
	},
	white: {
		opacity: 0.1,
		background: {
			default: neutralWhite,
			hover: neutralWhite,
			active: neutralWhite,
			disabled: neutralWhite,
		},
		icon: {
			default: primary800,
			hover: blue400,
			active: primary500,
			disabled: primary800,
		},
		color: {
			default: primary800,
			hover: blue400,
			active: primary500,
			disabled: primary800,
		},
		border: {
			default: neutral200,
			hover: blue400,
			active: primary500,
			disabled: primary500,
		},
	},
	primary: {
		opacity: 0.5,
		background: {
			default: primary500,
			hover: primary400,
			active: primary700,
			disabled: primary500,
		},
		icon: sameColorEveryState(neutralWhite),
		color: sameColorEveryState(neutralWhite),
		border: {
			default: primary500,
			hover: primary400,
			active: primary700,
			disabled: primary500,
		},
	},
	secondary: {
		opacity: 0.5,
		background: {
			default: primary50,
			hover: neutral200,
			active: neutral400,
			disabled: primary50,
		},
		icon: sameColorEveryState(primary400),
		color: sameColorEveryState(primary800),
		border: {
			default: primary50,
			hover: neutral200,
			active: neutral400,
			disabled: primary50,
		},
	},
	danger: {
		opacity: 0.5,
		background: {
			default: red25,
			hover: red50,
			active: red50,
			disabled: red25,
		},
		icon: sameColorEveryState(red500),
		color: sameColorEveryState(red500),
		border: {
			default: red100,
			hover: red100,
			active: red300,
			disabled: red100,
		},
	},
	ghost: {
		opacity: 0.5,
		background: {
			default: 'transparent',
			hover: 'transparent',
			active: 'transparent',
			disabled: 'transparent'
		},
		icon: sameColorEveryState(blue400),
		color: sameColorEveryState(blue400),
		border: {
			default: 'transparent',
			hover: 'transparent',
			active: 'transparent',
			disabled: 'transparent'
		},
	},
	link: {
		opacity: 0.5,
		background: {
			default: 'transparent',
			hover: 'transparent',
			active: 'transparent',
			disabled: 'transparent'
		},
		icon: sameColorEveryState(blue400),
		color: sameColorEveryState(blue400),
		border: {
			default: 'transparent',
			hover: 'transparent',
			active: 'transparent',
			disabled: 'transparent'
		},
	},
	gradient: {
		opacity: 0.5,
		background: {
			default: 'linear-gradient(90deg, #2B88FF 0%, #005FD7 100%)',
			// eslint-disable-next-line max-len
			hover: 'linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), linear-gradient(90deg, #0261D8 0%, #2B88FF 100%)',
			// eslint-disable-next-line max-len
			active: 'linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), linear-gradient(90deg, #0261D8 0%, #2B88FF 100%)',
			disabled: 'linear-gradient(90deg, rgba(43, 136, 255, 0.50) 0%, rgba(0, 95, 215, 0.50) 100%)',
		},
		icon: sameColorEveryState(neutralWhite),
		color: sameColorEveryState(neutralWhite),
		border: null
	}

};
